import {Cookies} from 'react-cookie';
import {
    AUTH_USER,
    AUTH_PENDING,
    AUTH_ERROR,
    UNAUTH_USER,
    AUTH_USER_ERROR_HANDLED,
    REFRESH_USER,
    REFRESH_PENDING,
    FORGOT_PASSWORD_EMAIL_SENT,
    REFRESH_ERROR,
    EDITING_USER
} from './types';
import {resetAppsAction} from '../apps/actions';
import {adminsResetAction} from '../admins/actions';
import APIService from '../../services/api'
import {handleError} from '../infos/actions'

const cookies = new Cookies();

export function setCookies(user, rememberme) {
    let maxAge = 60 * 60 * 24;
    if (rememberme || false) {
        maxAge = 60 * 60 * 24 * 7;
    }
    cookies.set('token', user.token, {
        path: '/',
        maxAge: maxAge
    });
    cookies.set('refresh', user.refresh_token, {path: '/'});
    if('id' in user) {
        cookies.set('user', user, {
            path: '/',
            maxAge: maxAge
        });
    }
}

function deleteCookies() {
    cookies.remove('token');
    cookies.remove('refresh');
    cookies.remove('user');
}

// Action creators

export const authUserErrorHandlerAction = () => {
    return {type: AUTH_USER_ERROR_HANDLED};
};

export const authPendingAction = () => {
    return {type: AUTH_PENDING};
};

export const editingUserAction = () => {
    return {type: EDITING_USER};
};

export const refreshPendingAction = () => {
    return {
        type: REFRESH_PENDING,
        payload: window.location.pathname
    };
};

export const forgotPasswordEmailSendAction = () => {
    return {type: FORGOT_PASSWORD_EMAIL_SENT};
};

export const authUserAction = (user) => {
    return {
        type: AUTH_USER,
        payload: user
    };
};

export const refreshUserAction = (user) => {
    return {
        type: REFRESH_USER,
        payload: user
    };
};

export const unauthUserAction = () => {
    return {type: UNAUTH_USER};
};

// Actions

export function errorHandled() {
    return (dispatch) => {
        dispatch(authUserErrorHandlerAction());
    }
}

export function forgotPassword(email) {
    return (dispatch) => {
        dispatch(authPendingAction());
        return APIService
            .forgotPassword(email)
            .then(() => {
                dispatch(forgotPasswordEmailSendAction());
            })
            .catch((error) => {
                // For security reasons, we do not show that the request may fail
                // dispatch(handleError(error, AUTH_ERROR))
                dispatch(forgotPasswordEmailSendAction());
            });
    }
}

export function loginUser({login, password, rememberme}) {
    return (dispatch) => {
        dispatch(authPendingAction());
        return APIService
            .login({login, password, rememberme})
            .then(user => {
                setCookies(user, rememberme);
                dispatch(authUserAction(user));
            })
            .catch((error) => {
                console.log(error, AUTH_ERROR)
                dispatch(handleError(error, AUTH_ERROR))
            });
    }
}

export function logoutUser() {
    return (dispatch) => {
        dispatch(adminsResetAction());
        dispatch(resetAppsAction());
        dispatch(unauthUserAction());
        deleteCookies();
    }
}

export function refreshUser() {
    return (dispatch) => {
        dispatch(refreshPendingAction());
        return APIService
            .refresh({
                'refresh': cookies.get('refresh')
            })
            .then(user => {
                setCookies(user, false);
                dispatch(refreshUserAction(user));
            })
            .catch((error) => {
                dispatch(handleError(error, REFRESH_ERROR))
            });
    }
}

export function editAdmin(admin) {
    return (dispatch) => {
        dispatch(editingUserAction());
        return APIService
            .editAdmin(admin, cookies.get('token'))
            .then(admin => {
                const oldUser = cookies.get('user');
                const newUser = {
                    ...admin,
                    token: oldUser.token,
                    refresh_token: oldUser.refresh_token
                };

                setCookies(newUser, false);
                dispatch(authUserAction(newUser));
            })
            .catch((error) => {
                dispatch(handleError(error, AUTH_ERROR))
            });
    }
}



// WEBPACK FOOTER //
// src/store/auth/actions.js